import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import KimiyaLogo from "@kimiya/core/images/kimiya-logo-blue.svg"

import useChatStyles from "@kimiya/custom/coach/chat.styles"

const NoChatMessages = () => {

    const classes = useChatStyles()

    return (
        <Grid container justifyContent="center" alignItems="center" className={classes.noChatContainer}>
            <Grid item align="center">
                <img src={KimiyaLogo} alt="Kimiya Logo" />
                <Typography variant="h4" color="primary">Nessun messaggio presente!</Typography>
                <Typography variant="body2" color="secondary">Al momento non sono presenti messaggi per questa chat</Typography>
            </Grid>
        </Grid>
    )
}

export default NoChatMessages